import { render, staticRenderFns } from "./VaItem.vue?vue&type=template&id=6ad2a176&"
import script from "./VaItem.vue?vue&type=script&lang=js&"
export * from "./VaItem.vue?vue&type=script&lang=js&"
import style0 from "./VaItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports